<template>
  <div class="not-found-container">
    <div class="not-found-content">
      <div class="error-code">404</div>
      <div class="error-title">页面未找到</div>
      <div class="error-description">
        抱歉，您访问的页面不存在或已被移除。
      </div>
      <div class="actions">
        <router-link to="/" class="back-home-btn">
          返回首页
        </router-link>
        <button class="go-back-btn" @click="goBack">
          返回上一页
        </button>
      </div>
    </div>
    <div class="not-found-image">
      <span class="icon iconfont icon-not-found"></span>
<!--      <svg class="astronaut-wire" viewBox="-9 -9 259 823" width="259" height="823">
        <path d="M241 0c-24 54-30 113-78 148S63 159 27 215c-35 55 32 102 73 141s103 94 98 166c-6 97-169 66-192 157-10 43-8 84 9 126" fill="none" stroke-width="6" stroke="#FFF"></path>
      </svg>
      <div class="circle"></div>
      <div class="circle-outer"></div>
      <div class="stars">
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
        <div class="star"></div>
      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  methods: {
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/');
    }
  }
}
</script>

<style scoped>
.not-found-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 20px;
  background-color: #1e293b;
  color: #fff;
  position: relative;
  overflow: hidden;
}

@media (min-width: 768px) {
  .not-found-container {
    flex-direction: row;
    justify-content: space-around;
  }
}

.not-found-content {
  text-align: center;
  max-width: 500px;
  z-index: 10;
  margin-bottom: 40px;
}

@media (min-width: 768px) {
  .not-found-content {
    text-align: left;
    margin-bottom: 0;
  }
}

.error-code {
  font-size: 120px;
  font-weight: 700;
  line-height: 1;
  color: #3b82f6;
  margin-bottom: 10px;
  text-shadow: 0 0 10px rgba(59, 130, 246, 0.5);
}

.error-title {
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 16px;
}

.error-description {
  font-size: 18px;
  margin-bottom: 30px;
  color: #cbd5e1;
  line-height: 1.6;
}

.actions {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

@media (min-width: 480px) {
  .actions {
    flex-direction: row;
    justify-content: center;
  }

  @media (min-width: 768px) {
    .actions {
      justify-content: flex-start;
    }
  }
}

.back-home-btn, .go-back-btn {
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-block;
}

.back-home-btn {
  background-color: #3b82f6;
  color: white;
  border: none;
}

.back-home-btn:hover {
  background-color: #2563eb;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.5);
}

.go-back-btn {
  background-color: transparent;
  color: #cbd5e1;
  border: 1px solid #475569;
}

.go-back-btn:hover {
  background-color: rgba(255, 255, 255, 0.1);
  transform: translateY(-2px);
}

.not-found-image {
  position: relative;
  width: 100%;
  max-width: 400px;
  height: 300px;
  z-index: 5;
}

@keyframes float {
  0%, 100% {
    transform: translate(-50%, -50%);
  }
  50% {
    transform: translate(-50%, -60%);
  }
}

@keyframes pulse {
  0%, 100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.3;
  }
  50% {
    transform: translate(-50%, -50%) scale(1.2);
    opacity: 0.2;
  }
}

@keyframes rotate {
  from {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  to {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

@keyframes twinkle {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 300px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
